import { dashBoardConstants } from '../../_constants/dashBoard.constants';

const initialState = { final_assessment_load : true, final_assessment_data: '', final_assessment_error: false};

export function final_assessment_reducer(state = initialState, action) {
    switch (action.type) {
        case dashBoardConstants.REQUEST_FINAL_ASSESSMENTS:
        return {
            final_assessment_load: true,
            final_assessment_data: '',
            final_assessment_error: false
        };
      case dashBoardConstants.RECIEVE_FINAL_ASSESSMENTS:
        return {
            final_assessment_load: false,
            final_assessment_data: action.edit_asessement,
            final_assessment_error: false
        };
      case dashBoardConstants.ERROR_FINAL_ASSESSMENTS:
        return { 
            final_assessment_load: false,
            final_assessment_data: action.error.response.data.message,
            final_assessment_error: true
        };
      default:
        return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/dashBoard/final_assessment.reducer.js